export default "__VITE_ASSET__ec04983f__"